import * as classNames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import * as styles from './TextLabel.css'

// Color
export const ColorType = {
  ACCENT: styles.accent,
  BASE: styles.base,
  MODEST: styles.modest,
  WHITE: styles.white
}

// Font Size
export const SizeType = {
  LARGE: styles.large,
  MEDIUM: styles.medium,
  SMALL: styles.small
}

// weight
export const WeightType = {
  HEAVY: styles.heavy,
  LIGHT: styles.light,
  NORMAL: styles.normal
}

interface TextLabelProps {
  children: any
  color?: string
  size?: string
  weight?: string
}

const TextLabel: React.FunctionComponent<TextLabelProps> = ({
  children,
  color = ColorType.BASE,
  size = SizeType.SMALL,
  weight = WeightType.LIGHT
}) => {
  const labelClass = classNames(styles.text, size, weight, color)
  return <p className={labelClass}>{children}</p>
}

export default compose<TextLabelProps, TextLabelProps>(pure)(TextLabel)
